import { AxiosResponse } from "axios";
import { RcFile } from "antd/lib/upload/interface";
import api from "../axiosInstance";

class UsersService {
  getUsers = async (): Promise<AxiosResponse> => {
    const response = await api.get("users");
    return response;
  };

  getUsersAdmin = async (): Promise<AxiosResponse> => {
    const response = await api.get("users/admin");
    return response;
  };

  getUser = async (id: string | number): Promise<AxiosResponse> => {
    const response = await api.get(`users/${id}`);
    return response;
  };

  getUserGroupsMembership = async (
    id: string | number
  ): Promise<AxiosResponse> => {
    const response = await api.get(`users/${id}/ticket-groups-member`);
    return response;
  };

  // TODO: dodać typ usera (form)
  createUser = async (user: any): Promise<AxiosResponse> => {
    const response = await api.post(`users`, user);
    return response;
  };

  editUser = async (id: number | string, user: any): Promise<AxiosResponse> => {
    const response = await api.patch(`users/${id}`, user);
    return response;
  };

  editOwnUser = async (user: any): Promise<AxiosResponse> => {
    const response = await api.patch(`users/me/edit`, user);
    return response;
  };

  deleteUser = async (id: string | number): Promise<AxiosResponse> => {
    const response = await api.delete(`users/${id}`);
    return response;
  };

  softDelete = async (id: string | number): Promise<AxiosResponse> => {
    const response = await api.delete(`users/${id}/soft`);
    return response;
  };

  uploadAvatar = async (
    id: string | number,
    file: string | RcFile | Blob
  ): Promise<AxiosResponse> => {
    const formData = new FormData();
    formData.set("avatar", file);
    const response = await api.post(`users/${id}/uploadAvatar`, formData);
    return response;
  };

  uploadOwnAvatar = async (
    file: string | RcFile | Blob
  ): Promise<AxiosResponse> => {
    const formData = new FormData();
    formData.set("avatar", file);
    const response = await api.post(`users/me/edit/uploadAvatar`, formData);
    return response;
  };

  getTags = async (): Promise<AxiosResponse> => {
    const response = await api.get("users/tags");
    return response;
  };

  updateMeta = async (meta: any) => {
    const response = await api.post(`users/meta`, { meta });
    return response;
  };
}

export default new UsersService();
